var map = {
	"./content_block": "YCuh",
	"./content_block/": "YCuh",
	"./content_block/content_block.module.scss": "K9Z4",
	"./content_block/index": "YCuh",
	"./content_block/index.js": "YCuh",
	"./image": "tZUS",
	"./image/": "tZUS",
	"./image/image.module.scss": "LgZ3",
	"./image/index": "tZUS",
	"./image/index.js": "tZUS",
	"./instagram_embed": "XDK7",
	"./instagram_embed/": "XDK7",
	"./instagram_embed/index": "XDK7",
	"./instagram_embed/index.js": "XDK7",
	"./instagram_embed/instagram_embed.module.scss": "0J2K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vR7s";